import React from 'react';
import { Container } from '../components/Container';
import { Store, DollarSign, Users, Clock, CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TeamStores() {
  return <div className="w-full bg-white" data-id="element-616">
      {/* Hero */}
      <div className="bg-[#111827] text-white py-20" data-id="element-617">
        <Container data-id="element-618">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-619">
            <div className="lg:w-1/2" data-id="element-620">
              <h1 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-4" data-id="element-621">
                Custom Team Stores
              </h1>
              <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-622"></div>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-623">
                Take the hassle out of ordering fan gear. Open a custom online
                store for your organization, let parents order directly, and
                raise funds effortlessly.
              </p>
              <Link to="/contact" className="inline-block bg-pts-red hover:bg-pts-red-dark text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-624">
                Start a Team Store
              </Link>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-625">
              <img src="https://images.unsplash.com/photo-1556906781-9a412961c28c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Team Store on Mobile" className="rounded-xl shadow-2xl border border-gray-800" data-id="element-626" />
            </div>
          </div>
        </Container>
      </div>

      {/* How It Works */}
      <section className="py-20 bg-gray-50" data-id="element-627">
        <Container data-id="element-628">
          <div className="text-center mb-16" data-id="element-629">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-630">
              How Team Stores Work
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto" data-id="element-631"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-632">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-633">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-634">
                1
              </div>
              <Store className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-635" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-636">
                We Build the Store
              </h3>
              <p className="text-gray-600" data-id="element-637">
                You pick the gear and provide your logos. We build a custom,
                mobile-friendly online store for your organization.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-638">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-639">
                2
              </div>
              <Users className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-640" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-641">
                Parents & Fans Order
              </h3>
              <p className="text-gray-600" data-id="element-642">
                Share the link with your organization. Everyone orders and pays
                individually during a set time window.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-643">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-644">
                3
              </div>
              <Clock className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-645" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-646">
                We Produce & Ship
              </h3>
              <p className="text-gray-600" data-id="element-647">
                The store closes, we produce all the orders together, and ship
                them out. No inventory or money collection for you.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Fundraising */}
      <section className="py-20 bg-white border-y border-gray-200" data-id="element-648">
        <Container data-id="element-649">
          <div className="flex flex-col md:flex-row items-center gap-12 max-w-5xl mx-auto" data-id="element-650">
            <div className="md:w-1/3 flex justify-center" data-id="element-651">
              <div className="w-48 h-48 bg-red-50 rounded-full flex items-center justify-center border-8 border-white shadow-xl" data-id="element-652">
                <DollarSign className="h-24 w-24 text-pts-red" data-id="element-653" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-654">
              <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-655">
                Built-In Fundraising
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-656">
                Team stores are one of the easiest ways to raise money for your
                program. We provide you with our base factory-direct pricing,
                and you decide how much markup to add to each item.
              </p>
              <ul className="space-y-3" data-id="element-657">
                <li className="flex items-center text-gray-700" data-id="element-658">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-659" /> You
                  control the retail price
                </li>
                <li className="flex items-center text-gray-700" data-id="element-660">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-661" /> We send
                  you a check for the profits after the store closes
                </li>
                <li className="flex items-center text-gray-700" data-id="element-662">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-663" /> No
                  upfront costs or leftover inventory
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>

      {/* Tiers */}
      <section className="py-20 bg-gray-50" data-id="element-664">
        <Container data-id="element-665">
          <div className="text-center mb-16" data-id="element-666">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-667">
              Store Setup Options
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-668"></div>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-669">
              Choose the store tier that fits your organization's size and
              needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-670">
            {/* Starter */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-671">
              <div className="p-6 bg-gray-100 text-center border-b border-gray-200" data-id="element-672">
                <h3 className="font-oswald text-2xl font-bold uppercase text-gray-900" data-id="element-673">
                  Starter Store
                </h3>
              </div>
              <div className="p-6 flex-grow" data-id="element-674">
                <ul className="space-y-4 text-sm text-gray-600" data-id="element-675">
                  <li className="flex items-start" data-id="element-676">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-677" />{' '}
                    Up to 5 custom items
                  </li>
                  <li className="flex items-start" data-id="element-678">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-679" />{' '}
                    Standard design templates
                  </li>
                  <li className="flex items-start" data-id="element-680">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-681" />{' '}
                    14-day open window
                  </li>
                  <li className="flex items-start" data-id="element-682">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-683" />{' '}
                    Bulk shipping to one location
                  </li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto" data-id="element-684">
                <Link to="/contact" className="block w-full text-center bg-gray-900 hover:bg-gray-800 text-white py-3 rounded font-bold uppercase text-sm transition-colors" data-id="element-685">
                  Contact for Pricing
                </Link>
              </div>
            </div>

            {/* Standard */}
            <div className="bg-white rounded-xl shadow-md border-2 border-pts-red overflow-hidden flex flex-col relative transform md:-translate-y-4" data-id="element-686">
              <div className="absolute top-0 inset-x-0 bg-pts-red text-white text-xs font-bold uppercase text-center py-1" data-id="element-687">
                Most Popular
              </div>
              <div className="p-6 bg-[#111827] text-center border-b border-gray-800 pt-8" data-id="element-688">
                <h3 className="font-oswald text-2xl font-bold uppercase text-white" data-id="element-689">
                  Standard Store
                </h3>
              </div>
              <div className="p-6 flex-grow" data-id="element-690">
                <ul className="space-y-4 text-sm text-gray-600" data-id="element-691">
                  <li className="flex items-start" data-id="element-692">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-693" />{' '}
                    Up to 12 custom items
                  </li>
                  <li className="flex items-start" data-id="element-694">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-695" />{' '}
                    Custom artwork support
                  </li>
                  <li className="flex items-start" data-id="element-696">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-697" />{' '}
                    Flexible open window
                  </li>
                  <li className="flex items-start" data-id="element-698">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-699" />{' '}
                    Fundraising markup enabled
                  </li>
                  <li className="flex items-start" data-id="element-700">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-701" />{' '}
                    Individual shipping available
                  </li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto" data-id="element-702">
                <Link to="/contact" className="block w-full text-center bg-pts-red hover:bg-pts-red-dark text-white py-3 rounded font-bold uppercase text-sm transition-colors" data-id="element-703">
                  Contact for Pricing
                </Link>
              </div>
            </div>

            {/* Premium */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-704">
              <div className="p-6 bg-gray-100 text-center border-b border-gray-200" data-id="element-705">
                <h3 className="font-oswald text-2xl font-bold uppercase text-gray-900" data-id="element-706">
                  Premium Store
                </h3>
              </div>
              <div className="p-6 flex-grow" data-id="element-707">
                <ul className="space-y-4 text-sm text-gray-600" data-id="element-708">
                  <li className="flex items-start" data-id="element-709">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-710" />{' '}
                    Unlimited items
                  </li>
                  <li className="flex items-start" data-id="element-711">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-712" />{' '}
                    Premium custom design
                  </li>
                  <li className="flex items-start" data-id="element-713">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-714" />{' '}
                    Year-round store options
                  </li>
                  <li className="flex items-start" data-id="element-715">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-716" />{' '}
                    Advanced fundraising tracking
                  </li>
                  <li className="flex items-start" data-id="element-717">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-2 flex-shrink-0" data-id="element-718" />{' '}
                    Dedicated account manager
                  </li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto" data-id="element-719">
                <Link to="/contact" className="block w-full text-center bg-gray-900 hover:bg-gray-800 text-white py-3 rounded font-bold uppercase text-sm transition-colors" data-id="element-720">
                  Contact for Pricing
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>;
}